import { QueryClient } from '@tanstack/react-query';

import { useDictionary } from '@/shared/lib/i18n';
import { toast } from '@/shared/lib/toast';
import { QueryKey } from '@/types/query';

export const useRejectCandidateMutationCallbacks = (queryClient: QueryClient) => {
  const dictionary = useDictionary();

  return {
    onSuccess: () => {
      toast.success(dictionary.candidateRejectedSuccessfully);
      queryClient.removeQueries([QueryKey.useBestMatchesInfiniteQuery], { exact: false });
      queryClient.removeQueries([QueryKey.useRatedCandidatesQuery], { exact: false });
      queryClient.removeQueries([QueryKey.useRatedCandidatesStats], { exact: false });
      queryClient.invalidateQueries([QueryKey.useCandidateHistoryQuery], { exact: false });
    },
    onError: () => {
      toast.error(dictionary.somethingWentWrong);
    },
  };
};
